import React, { useState } from 'react';
import { useStyles } from "../styles/styles";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from '@mui/material/Grid';
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";

const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const setAgreed = props.setAgreed;
    const component = props.component;
    const agreeText = props.agreeText;
    const classes = useStyles;
    const [showCompleted, setShowCompleted] = useState(false);

    return (
        <>
            <Dialog
                open={open}
                maxWidth='md'
                fullWidth
                sx={classes.dialog}
                scroll="paper"
                aria-describedby="scroll-dialog-description"
                slotProps={{
                    paper: {
                        'aria-label': 'Accept Conditions'
                    }
                }}
            >
                <DialogContent dividers>
                    <DialogContentText id="scroll-dialog-description">
                        {component}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        spacing={3}
                        alignItems="top"
                    >
                        <Grid item xs={6} >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="agree"
                                        color='primary'
                                        sx={{marginLeft: {xs: '1rem', md: '1.5rem', lg: '2.5rem'}, paddingBottom: '.5rem'}}
                                        defaultChecked={false}
                                        onChange={(e) => {setAgreed(e.target.checked); setShowCompleted(e.target.checked)}}
                                    />
                                }
                                label={
                                    <Typography variant='subtitle1' color='secondary' sx={{fontSize: {xs: '1rem', sm: '1.2rem'}, lineHeight: {xs: '1rem', sm: '1.2rem'}}}>
                                        {agreeText ? agreeText : 'I agree to these terms and conditions'}
                                    </Typography>
                                }
                                sx={{...classes.checkbox, paddingTop: '1rem'}}
                            />
                        </Grid>
                        <Grid item xs={6} sx={{textAlign: 'right', paddingRight: '3rem'}}>
                            <Button
                                variant='outlined'
                                color="primary"
                                sx={classes.squashedButton}
                                onClick={() => {setAgreed(false); setDone(true);}}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant='contained'
                                color="primary"
                                sx={classes.squashedButton}
                                disabled={!showCompleted}
                                onClick={() => {setDone(true)}}
                            >
                                Continue
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Popup;
